<template>
<div class="aarrow_box">
  <v-card-text>
  <h5 class="accent--text" style="font-size: 12px; font-weight:700"> Auction Files </h5>
  <table class="table">
    <thead class="thead">
      <tr>
        <th scope="col">File Name</th>
        <th scope="col">Lots</th>
        <th scope="col">Uploaded By</th>
        <th scope="col">Status</th>
        <th scope="col">Date</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in paginatedFiles" v-bind:key="item.id">
        <td>{{ item.fileName }}</td>
        <td>{{ item.numberOfLots }}</td>
        <td>{{ item.createdBy }}</td>
        <td>{{ item.status.statusName }}</td>
        <td>{{ item.created | prettyDate }}</td>
      </tr>
    </tbody>
  </table>
  </v-card-text>
  <v-card-actions>
    <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
    <v-spacer></v-spacer>
    <v-pagination
    v-model="page"
    :length="numberOfLinks"
    :total-visible="7"
    color="secondary"
                class="accent--text logoutbtn"
  ></v-pagination>
  </v-card-actions>
</div>
</template>
<script>
import axios from 'axios'
import config from '../../config'

export default {
  name: 'AuctionFilesDash',
  data: function () {
    return {
      items: [],
      paginatedFiles: [],
      numberOfLinks: 0,
      numberOfItemsPerPage: 5,
      page: 1
    }
  },
  mounted () {
    this.getDataFromApi()
  },
  watch: {
    items: function () {
      this.paginatedFiles = this.paginationMethod(this.items, 1, this.numberOfItemsPerPage)
      this.numberOfLinks = Math.ceil(this.items.length / this.numberOfItemsPerPage)
    },
    page: function (val) {
      this.paginatedFiles = this.paginationMethod(this.items, val, this.numberOfItemsPerPage)
    }
  },
  methods: {
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const items = this.getAuctionFiles()
        const total = items.length
        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    paginationMethod (items, pageNumber, limitPerPage) {
      pageNumber = pageNumber - 1
      const from = pageNumber * limitPerPage
      let to = (pageNumber + 1) * limitPerPage
      if (to >= items.length) {
        to = items.length
      }
      return items.slice(from, to)
    },
    getAuctionFiles () {
      var url = config.serverURI + '/upload/auction/getAll'
      axios.get(url)
        .then(response => {
          this.items = response.data
          this.$emit('updateAuctionFilesCount', this.items.length)
        })
        .catch(error => {
          console.log('error', error.response)
        })
      return this.items
    }
  }
}
</script>
<style>
.aarrow_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
  border-radius: 5px;
}
.aarrow_box:after, .aarrow_box:before {
  bottom: 100%;
  left: 60%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.aarrow_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #fff;
  border-width: 20px;
  margin-left: -20px;
}
.aarrow_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-bottom-color: #707070;
  border-width: 21px;
  margin-left: -21px;
}
</style>
